export default {
  diffusionInputs: 'Dane wejściowe dyfuzji',
};
